export default "/images/ce8676720c1c47b0a0231f0da62a9624.avif";